import React from 'react'
import { QuestionFrame, YesNoQuestion } from 'components/questions'


export const Q10 = () => {
  return (
    <QuestionFrame q={10}>
      <YesNoQuestion num={1} content={'受電方式は、本線・予備電源、本線・予備線、スポットネットワーク、ループ受電のいずれかに該当しますか。'} />
      <YesNoQuestion num={2} content={'共用部に供給する電力の保安用自家用発電機（BCP用等）がありますか。'} />
      <YesNoQuestion num={3} content={'専有部に供給する電力の保安用自家用発電機（BCP用等）がありますか。'} />
      <YesNoQuestion num={4} content={'停電時に利用可能なコジェネレーション設備がありますか。'} />
      <YesNoQuestion num={5} content={'停電時に利用可能な創エネ設備（太陽光、風力発電等）がありますか。'} />
    </QuestionFrame>
  )
}
